import {
  Table,
  Row,
  Cell,
  Sortable,
  IconButton,
  Button,
  Chip,
  color,
} from '@workboard/wobo-ui';
import styled, { css } from 'styled-components';
import Search from '@material-ui/icons/Search';
import { COLORS } from './colors';
import { SIZES } from './sizes';

const popupMinWidth = '580px';

export const InputWrapper = styled.div<{
  isMobile: boolean;
}>`
  width: 100%;
  display: flex;
`;

export const SearchTextInput = styled.input<{
  isFocused: boolean;
  isMobile: boolean;
}>`
  width: 100%;
  min-width: ${({ isMobile }) => isMobile && popupMinWidth};
  height: ${SIZES.SIZE_32};
  padding-left: ${SIZES.SIZE_32};
  padding-right: ${SIZES.SIZE_32};
  background: ${COLORS.white};
  border-radius: ${SIZES.SIZE_44};
  border: ${({ isFocused }) =>
    `1px solid ${isFocused ? COLORS.blue_500 : '#C4CBD7'}`};
  color: rgb(51, 57, 67);
  font-size: ${SIZES.SIZE_14};
  font-family: Lato;
  box-shadow: ${({ isFocused }) =>
    isFocused && '-8px 0px 4px 0px rgba(255, 255, 255, 0.96)'};

  &::placeholder {
    color: ${COLORS.coolGrey_600} !important;
    font-size: ${SIZES.SIZE_14};
    font-style: italic !important;
  }

  &:focus {
    outline: none;
  }
`;

export const SearchIcon = styled(Search)`
  display: inline-flex;
  z-index: 1;
  margin-right: -28px;
  margin-top: ${SIZES.SIZE_6};
  color: rgb(196, 203, 215) !important;
`;

export const CloseIconButton = styled(IconButton)`
  width: 24px;
  height: 24px;
  margin-left: -30px;
  top: ${SIZES.SIZE_4};

  span {
    display: flex;
  }
  svg {
    width: 1rem;
    height: 1rem;
  }
`;

export const BREAKPOINTS = {
  xs: '(max-width: 600px)',
  sm: '(max-width: 720px)',
  md: '(max-width: 900px)',
  lg: '(max-width: 980px)',
  xl: '(max-width: 1100px)',
  xxl: '(max-width: 1200px)',
};

export const StyledChip = styled(Chip)`
  svg {
    color: #687587 !important;
    width: 20px;
    height: 20px;
  }
  ${({ $active }) =>
    $active &&
    css`
      color: #005f8f !important;
      cursor: auto !important;
      svg.MuiChip-avatar {
        color: #005f8f !important;
      }
      svg {
        color: #005f8f !important;
      }
    `}
  cursor:pointer;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.15;
  padding: 4px, 12px, 4px, 8px;

  .MuiChip-label {
    font-weight: 700;
  }
  svg.MuiChip-avatar {
    height: 20px;
    width: 20px;
    color: #687587;
  }
  &.MuiChip-clickable:focus {
    background-color: #e1f2fa !important;
  }
  &.MuiChip-outlined.MuiChip-clickable:focus {
    background-color: inherit !important;
  }
`;

export const SearchWrapper = styled('div')`
  right: 110px;
  min-width: 280px;
`;

export const RespSearchWrapper = styled('div')`
  width: 100%;
  margin-bottom: 16px;
`;

export const CalDiv = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15;
  padding-bottom: 12px;
  display: flex;
`;

export const TeamsNameLink = styled(Button)`
  color: #333943;
  display: block;
  font-weight: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 5px;
  min-width: 50px;
  text-align: start;

  &:hover,
  &:focus-within,
  &:focus {
    color: #333943;
    background: inherit;
    text-decoration: underline;
  }
`;

export const StyledRow = styled(Row)`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.15;

  &:hover,
  &:focus-within,
  &:focus {
    background: rgb(247, 249, 250);

    button {
      opacity: 1;
    }
  }
`;

export const StyledTable = styled(Table)`
  overflow: visible;

  table + div {
    flex-wrap: wrap;
  }

  tr:empty {
    display: none;
  }

  tbody.MuiTableBody-root {
    tr {
      height: 56px !important;
    }
  }

  thead.MuiTableHead-root {
    tr.MuiTableRow-head {
      th.columnType {
        span {
          font-size: 0px;
        }
      }
    }
  }
  .MuiTablePagination-root {
    .MuiTablePagination-toolbar {
      padding-left: 20px;
    }

    .MuiTablePagination-selectRoot {
      margin-right: 16px;
    }

    .MuiTablePagination-actions {
      button {
        margin: 4px;
        padding: 4px;
      }
    }
  }
`;

export const StyledCell = styled(Cell)`
  padding: 8px 13.5px;
  overflow: hidden;
  text-overflow: ellipsis;

  button {
    padding: 0;
  }
`;

export const StyledSortable = styled(Sortable)`
  background: #fff;
  padding: 8px 13.5px;
`;

export const Wrapper = styled('div')`
  display: flex;
  flex-grow: 1;
  column-gap: ${({ theme }) => theme.spacing(1)}px;

  .MuiChip-label {
    font-weight: 700 !important;
  }
  // selected chip on hover color
  .glHBLL.MuiChip-clickable:not(.disable-hover-active):hover {
    background-color: #e1f2fa !important;
  }
`;

export const FilterWrapper = styled('div')`
  display: flex;
  column-gap: ${({ theme }) => theme.spacing(1)}px;
  justify-content: space-between;
  position: relative;
  margin-bottom: 28px;
`;

export const FilterHeader = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize}px;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 700;
`;

export const EmptyWrapper = styled.div`
  width: 100%;
  margin-top: 32px;
  text-align: center;

  svg {
    width: 20%;
  }
`;

const isActiveFilterChip = css`
  color: ${color('--blue-600')};
`;

const AdvFilterChip = styled(Chip)`
  .MuiChip-icon {
    width: 1.125rem;
    height: 1.125rem;
  }

  span {
    font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  }
  div {
    font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  }

  &.MuiChip-root {
    &.MuiChip-outlined {
      border-radius: ${({ theme }) => theme.spacing(2)}px;
    }

    .MuiChip-icon {
      color: ${color('--gray-500')};
      ${({ type }) => type === 'filtered' && isActiveFilterChip}
    }

    span {
      ${({ type }) => type === 'filtered' && isActiveFilterChip}
    }
  }
`;

export const StyledFilterChip = styled(AdvFilterChip)`
  ${({ $selected }) =>
    $selected &&
    css`
      .MuiChip-deleteIcon {
        color: #005f8f !important;
      }
    `}
  cursor: pointer;

  > span {
    padding-left: ${({ theme }) => theme.spacing(1.75)}px;
  }

  .chip-icon-backdrop {
    .MuiSvgIcon-root {
      ${({ type }) => type === 'filtered' && isActiveFilterChip}
    }

    &:hover {
      background-color: transparent !important;
    }
  }
`;

export const PopoverFooter = styled.div`
  border-top: 1px solid ${color('--black-opacity-6')};
  display: flex;
  justify-content: flex-end;
  padding: ${({ theme }) => `${theme.spacing(1)}px ${theme.spacing(1.5)}px`};
`;

export const ActiveFiltersWrapper = styled.div`
  display: flex;
`;

export const FiltersWrapper = styled.div`
  display: flex;
  padding-left: calc(${({ theme }) => theme.spacing(2)}px + 1px);
  position: relative;
  ${({ $display }) =>
    $display &&
    css`
      margin-left: ${({ theme }) => theme.spacing(3)}px;
      &:before {
        content: '';
        background-color: ${color('--gray-100')};
        display: block;
        width: 1px;
        height: ${({ theme }) => theme.spacing(3)}px;
        position: absolute;
        top: 2px;
        left: 0;
      }
    `}

  > span {
    line-height: 1.75rem;
    white-space: nowrap;
    font-size: 14px;
  }
`;

export const ChipsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing(1)}px;
  row-gap: 4px;
  padding-left: ${({ theme }) => theme.spacing(1)}px;

  button {
    margin-left: -2px !important;
  }
`;

export const ErrorMessage = styled.div`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  padding-top: 16px;
  text-align: center;
  letter-spacing: 0.15px;

  color: #333943;

  > div {
    font-weight: 400;
  }
`;
